module.exports = __webpack_public_path__ + "img/CM-BS-24-BMW-Modern.b41618e7.jpg";